/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class MetricDetailedData {
    getFixupPrototypeFunction() { return MetricDetailedData.fixupPrototype; }

    static newInstance(model: Partial<MetricDetailedData>): MetricDetailedData {
        let obj = Object.assign(new MetricDetailedData(), model);
        MetricDetailedData.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<MetricDetailedData>): MetricDetailedData {
        if (!model) return null;
        return MetricDetailedData.newInstance(<MetricDetailedData> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: MetricDetailedData) {
        if (!obj) return;

        models.MetricDetailedData.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: MetricDetailedData): boolean {
        Object.setPrototypeOf(obj, MetricDetailedData.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.value === undefined) {
            this.value = 0;
        }
        if (typeof this.date === "string") {
            this.date = new Date(<string><any>this.date);
        }
    }

    /**
     * Time stamp For which metrics are being measured.
     */
    date: Date;

    /**
     * Value for the metric in the provided time frame.
     */
    value: number;

}
